export default {
    name: 'نام',
    tel: 'تلفن',
    save: 'صرفه جویی',
    confirm: 'تایید',
    cancel: 'لغو کنید',
    delete: 'حذف',
    complete: 'پایان',
    loading: 'بارگذاری...',
    telEmpty: 'لطفا شماره تلفن را پر کنید',
    nameEmpty: 'لطفا نام خود را وارد کنید',
    nameInvalid: 'لطفا یک نام معتبر وارد کنید',
    confirmDelete: 'آیا مطمئنید که میخواهید حذف کنید',
    telInvalid: 'لطفا شماره تلفن صحیح را وارد کنید',
    vanCalendar: {
        end: 'پایان',
        start: 'شروع کنید',
        title: 'عنوان',
        confirm: 'تایید',
        startEnd: 'شروع پایان',
        weekdays: ['روز', 'یکی', 'دو', 'سه', 'چهار', 'پنج', 'شش'],
    },
    vanCascader: {
        select: 'لطفا انتخاب کنید',
    },
    vanContactCard: {
        addText: 'افزودن شماره',
    },
    vanContactList: {
        addText: 'تماس جدید',
    },
    vanPagination: {
        prev: 'صفحه قبلی',
        next: 'صفحه بعد',
    },
    vanPullRefresh: {
        pulling: 'برای تازه کردن، پایین بکشید...',
        loosing: 'انتشار رفرش...',
    },
    vanSubmitBar: {
        label: 'همه:',
    },
    vanCoupon: {
        unlimited: 'بدون محدودیت استفاده',
    },
    vanCouponCell: {
        title: 'کوپن',
        tips: 'در دسترس نیست',
    },
    vanCouponList: {
        empty: 'بدون کوپن',
        exchange: 'تبادل',
        close: 'بدون کوپن',
        enable: 'قابل استفاده',
        disabled: 'در دسترس نیست',
        placeholder: 'لطفا کد تبلیغاتی را وارد کنید',
    },
    vanAddressEdit: {
        area: 'حوزه',
        postal: 'کد پستی',
        areaEmpty: 'منطقه را انتخاب کنید',
        addressEmpty: 'لطفا آدرس دقیق را وارد کنید',
        postalEmpty: 'فرمت کد پستی نادرست است',
        defaultAddress: 'به عنوان آدرس حمل و نقل پیش فرض تنظیم کنید',
        telPlaceholder: 'شماره تلفن همراه گیرنده',
        namePlaceholder: 'نام گیرنده',
        areaPlaceholder: 'استان/شهر/منطقه را انتخاب کنید',
    },
    vanAddressEditDetail: {
        label: 'نشانی',
        placeholder: 'شماره خیابان، شماره طبقه اتاق و غیره',
    },
    vanAddressList: {
        add: 'اضافه کردن آدرس',
    },
};
